import React, { Component } from 'react';
import { Row, Col, Container, PureGridProvider } from '../3rdparty/react-pure-grid';
import Session from '../services/session';
import i from '../imports';

const cardHeight = 200;

class BlogCardInBlog extends Component {

    render() {
        let heightOfText = cardHeight / 3;
        let positionTopText = cardHeight / 2.1

        return (
            <Col xs={12} md={4}>
                {/* <Row>
                    <Col xs={12} md={12}
                        style={{ fontSize: 20, marginBottom: 10 }}>
                        {this.props.title}
                    </Col>
                </Row>
                <i.NavLink to={this.props.url} style={{ color: "black", textDecoration: "none" }}>
                    <Col xs={12} md={12}
                        style={{
                            marinBottom: 10,
                            position: 'relative',
                            height: cardHeight,
                            backgroundImage: `url('${this.props.background}')`,
                            backgroundSize: 'cover', borderRadius: '0 0 0 0',
                        }}
                        className='card'>
                        <Row style={{ position: "relative", top: positionTopText, backgroundColor: '#FFFFFFC0' }}>
                            <Col xs={12} md={12}>
                                <Row style={{ height: heightOfText, paddingBottom: 7, overflow: "hidden" }}>
                                    <Col xs={12} md={12}>
                                        <span style={{ fontSize: 16, display: 'table-cell' }}>
                                            <p style={{
                                                textAlign: "left",
                                                textOverflow: 'ellipsis'
                                            }}>
                                                {this.props.children}
                                            </p>
                                        </span>
                                    </Col>
                                </Row>
                                {this.props.date ?
                                    <Row justify='end' style={{ paddingTop: 5 }}>
                                        <Col xs={12} md={8} >
                                            <div style={{ textAlign: "right", color: "#FF5563", fontSize: 15, fontWeight: "bold" }}>
                                                {Session.model.blog.date_of_publishing}: {(new Date(this.props.date)).toLocaleDateString("ru-RU")}
                                            </div>
                                        </Col>
                                    </Row>
                                    : null}
                            </Col>
                        </Row>
                    </Col>
                </i.NavLink> */}
                        <Row>
                    <Col style={{fontSize: 20, marginBottom: 10}}>
                        {this.props.title}
                    </Col>
                </Row>
            <i.NavLink to={this.props.url} style={{color: "black"}}>
                <div style={{marinBottom: 10, position: 'relative', height: 200, backgroundImage: `url('${this.props.background}')`, backgroundSize: 'cover'}} className='card'>
                    <div style={{ position: 'absolute', bottom: 0, left:0, right: 0, height: 70, width: '100%', display: 'table', backgroundColor: 'rgba(255, 255, 255, 0.753)', borderRadius: '0 0 10px 10px', paddingLeft:'2px'}}>
                        <span style={{fontSize: 16, verticalAlign: 'middle', display: 'table-cell'}}>
                            {this.props.children.length > 90 ? `${this.props.children.substr(0,87)}...` :this.props.children}
                            <div style={{ textAlign: "right", color: "#FF5563", fontSize: 15, paddingRight:10, fontWeight: "bold" }}>
                                                {Session.model.blog.date_of_publishing}: {(new Date(this.props.date)).toLocaleDateString("ru-RU")}
                            </div>                           
                        </span>
                    </div>
                </div>
            </i.NavLink>
            </Col>
        );
    }
}

class BlogCardsList extends Component {

    render() {

        const items = this.props.items;
        // console.log(items);

        return (
            <Container>
                <Row>
                    {items.map((item, index) => {
                        let url = i.Utils.locUrl(this.props.urlBuilder ? this.props.urlBuilder(item) : "");
                        return <BlogCardInBlog style={{ marginTop: 10 }} key={index}
                            title={item.title}
                            url={url}
                            date={item.date}
                            background={item.thumbnail}>{item.short_text}
                        </BlogCardInBlog>
                    })}
                </Row>
            </Container>
        );
    }
}

export {
    BlogCardInBlog,
    BlogCardsList
};